import $http from '../../utils/http';
// 公告信息
let commom = 'tio/complain/unit/';

export const getsubnodebyparenttxid = params => {
    // 区域选择
    return $http({
        url: commom + 'getsubnodebyparenttxid',
        params,
        method: 'GET'
    });
};

export default {
    getsubnodebyparenttxid
};